/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AddDocument from "../Modal/AddDocument";
import { useForm } from "react-hook-form";

import BtnLoader from "../../BtnLoader";
import ReactTost from "../../ReactTost";
import DeleteUrls from "../../User/Modal/DeleteUrls";

import UserDocDelete from "../../User/Modal/UserDocDelete";
import DocEdit from "../Modal/DocEdit";
import DeleteAllUrls from "../Modal/DeleteAllUrls";

const ChatBotSources = (props) => {
  const [addUploadModel, setUploadModel] = useState(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const { id, bot } = useParams();

  const [isUrl, setIsUrl] = useState(true);
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const [urls, setUrls] = useState("");
  const [user, setUser] = useState("");
  const [urlId, setUrlId] = useState();
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [addModalShow, setAddModalShow] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [urlLoading, setUrlLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [durationLoading, setDurationLoading] = useState(false);
  const [isDoc, setIsDoc] = useState(true);
  const [docId, setDocId] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;

  const [urlValue, setUrlValue] = useState();
  const [allUrls, setAllUrls] = useState([]);

  const [selectLabel, setSelectLabel] = useState("Select All");
  const [maxUrlCount, setMaxUrlCount] = useState("");

  const [urlError, setUrlError] = useState(false);
  // const { id } = useParams();
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm();
  const [monthly, setMontly] = useState(true);
  const [weekly, setWeekly] = useState(false);
  const [none, setNone] = useState(false);
  const [durationId, setDurationId] = useState("");
  const [urlEmpty, setUrlEmpty] = useState(false);
  const [urlSuccess, setUrlSuccess] = useState(false);
  const [scanUrlSuccess, setScanUrlSuccess] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteURLModalShow, setDeleteURLModalShow] = useState(false);

  const [checkWebUrls, setCheckWebUrls] = useState(false);
  const [scrapperName, setScrapperName] = useState(false);

  const [totalLength, setTotalLength] = useState(0);
  const [getUrls, setGetUrls] = useState([]);
  const [selectedUrlCheckboxes, setSelectedUrlCheckboxes] = useState([]);
  const [docList, setDocList] = useState([]);
  const [docIndex, setDocIndex] = useState(0);

  function updateDoc(event) {
    const checkboxId = event.target.value;

    if (event.target.checked) {
      setSelectedCheckboxes((prevSelected) => [...prevSelected, checkboxId]);
    } else {
      setSelectedUrlCheckboxes((prevSelected) =>
        prevSelected.filter((id) => id !== checkboxId)
      );
      setSelectedCheckboxes((prevSelected) =>
        prevSelected.filter((id) => id !== checkboxId)
      );
    }
  }

  const downloadFile = async (id, fileName, type) => {
    try {
      const response = await axios.get(`${API_URL}/download`, {
        params: {
          docId: id,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}.${type}`); //or any other extension
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      setType("danger");
      setMessage("File not found");
      setShowAlert(true);
      console.error("Error downloading file:", error);
      //setDownloadError('Error downloading file');
    }
  };


  async function indexingDocument() {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${API_URL}/${API_VERSION}/bot/index/${bot}`,
          {},
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((_response) => {
          resolve(true);
        })
        .catch((_error) => {
          reject(false);
          console.log(_error);
        });
    });
  }

  //saving documents
  function updateDocument(e) {
    //const combinedIds = [...selectedCheckboxes, ...selectedUrlCheckboxes];
    e.preventDefault();
    setSaveLoading(true);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/bot/${bot}`,
        {
          docs: [...selectedCheckboxes, ...selectedUrlCheckboxes],
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then(async (response) => {
        await indexingDocument()
          .then(() => {
            setMessage(t("Documents save successfully."));
            setType(t("Success"));
          })
          .catch(() => {
            setType("Danger");
            setMessage(t("Documents not save to gpt."));
          });
        setShowAlert(true);
        setSaveLoading(false);
      })
      .catch(() => {
        setSaveLoading(false);
        setType("Danger");
        setMessage(t("Something went wrong."));
        setShowAlert(true);
      });
  }


  function getAllDoc() {
    setLoading(true);
    axios
      .get(`${API_URL}/${API_VERSION}/user_doc?id=${user}&bot=${bot}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setLoading(false);
        setDocList(response.data.usersDoc);
        console.log("Document List", response.data.usersDoc);
        setGetUrls(response.data.usersUrls);
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went to wrong."));
        setShowAlert(true);
      });
  }

  async function scanWeb(data) {
    if (!durationId) {
      await axios
        .post(
          `${API_URL}/${API_VERSION}/urlDuration/`,
          {
            urlDuration: data.urlDuration,
            botId: bot,
            id: user,
          },
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setType(t("Success"));
          setMessage(t("Your data is send."));
          setShowAlert(true);
          setDurationLoading(false);
        })
        .catch((error) => {
          setDurationLoading(false);
          console.error("Error sending data:", error);
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    } else {
      setDurationLoading(true);
      await axios
        .patch(
          `${API_URL}/${API_VERSION}/urlDuration/${durationId}`,
          {
            urlDuration: data.urlDuration,
            botId: bot,
            id: user,
          },
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setType("Success");
          setMessage(t("Your data is send."));
          setShowAlert(true);
          setDurationLoading(false);
        })
        .catch((error) => {
          setDurationLoading(false);
          console.error("Error sending data:", error);
          setType("Danger");
          setMessage(t("Something went to wrong."));
          setShowAlert(true);
        });
    }
  }

  useEffect(() => {
    if (isDoc && user) {
      setIsDoc(false);
      getAllDoc();
    }
  }, [isDoc, user]);

  useEffect(() => {
    axios
      .get(`${API_URL}/${API_VERSION}/bot/${bot}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setUser(response.data.user);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_URL, API_VERSION, bot]);

  useEffect(() => {
    //for fetching user doc
    axios
      .get(`${API_URL}/${API_VERSION}/bot/${bot}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setScrapperName(response.data.settings.scrapperName);
        const receivedCheckboxIds = response.data.docs;
        setSelectedCheckboxes(receivedCheckboxIds);
        setSelectedUrlCheckboxes(receivedCheckboxIds);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_URL, API_VERSION, user]);

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <section className="sm-tabs admin_knowlegde_based">
        <Container>
          <Row className="justify-content-center">
            <Col md={12} className="mb-4">
              <Tabs
                onSelect={(index) => setDocIndex(index)}
                selectedIndex={docIndex}
              >
                <TabList className="d-flex justify-content-start">
                  <Tab>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-list-check"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="#05204a"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3.5 5.5l1.5 1.5l2.5 -2.5" />
                      <path d="M3.5 11.5l1.5 1.5l2.5 -2.5" />
                      <path d="M3.5 17.5l1.5 1.5l2.5 -2.5" />
                      <path d="M11 6l9 0" />
                      <path d="M11 12l9 0" />
                      <path d="M11 18l9 0" />
                    </svg>
                    {t("Choose files")}
                  </Tab>

                  <Tab>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-file-text"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="#05204a"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                      <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                      <path d="M9 9l1 0" />
                      <path d="M9 13l6 0" />
                      <path d="M9 17l6 0" />
                    </svg>
                    {t("My Files")}
                  </Tab>
                </TabList>
                <TabPanel className="">
                  <div className="option_box">
                    <Row>
                      <Col md={12}>
                        {docList.length <= 0 ? (
                          <div className="d-flex align-items-center justify-content-end flex-wrap mb-4">
                            <Link
                              className="userbutton"
                              onClick={() => setUploadModel(true)}
                            >
                              <i className="fa-solid fa-circle-plus"></i>
                              {t("New Document")}
                            </Link>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center justify-content-between flex-wrap mb-4">
                            <h4>{t("Choose Document")}</h4>
                            <Link
                              className="userbutton w-auto"
                              onClick={() => setUploadModel(true)}
                            >
                              <i className="fa-solid fa-circle-plus"></i>
                              {t("New Document")}
                            </Link>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        {docList &&
                          docList.map((doc, index) => {
                            return (
                              <>
                                <Form.Group
                                  className="mb-3"
                                  //controlId={index}
                                  key={doc.id}
                                >
                                  <Form.Check
                                    type="checkbox"
                                    id={doc.id}
                                    label={doc.name}
                                    checked={selectedCheckboxes.includes(
                                      doc.id
                                    )}
                                    value={doc.id}
                                    onChange={(e) => updateDoc(e, doc.id)}
                                  />
                                </Form.Group>
                              </>
                            );
                          })}
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col md={12}>
                        {docList.length > 0 || getUrls.length > 0 ? (
                          <div className="d-flex justify-content-end">
                            <button
                              type="submit"
                              onClick={updateDocument}
                              className="userbutton"
                              disabled={saveLoading}
                            >
                              {saveLoading ? <BtnLoader /> : t("Save")}
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                </TabPanel>

                <TabPanel>
                  <div className="option_box admin_fileList">
                    <Row>
                      <Col md={12}>
                        <div className="d-flex align-items-center justify-content-end mb-4">
                          <Link
                            className="userbutton"
                            onClick={() => setUploadModel(true)}
                          >
                            <i className="fa-solid fa-circle-plus"></i>
                            {t("New Document")}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                    <Row className="new_doc_tab">
                      {docList &&
                        docList.map((doc, index) => {
                          let iconClass;
                          switch (doc.type) {
                            case "pdf":
                              iconClass = "fa-file-pdf";
                              break;
                            case "doc":
                            case "docx":
                              iconClass = "fa-file-word";
                              break;
                            case "txt":
                              iconClass = "fa-file-alt";
                              break;
                            case "xls":
                            case "xlsx":
                              iconClass = "fa-file-excel";
                              break;
                            case "csv":
                              iconClass = "fa-file-csv";
                              break;
                            default:
                              iconClass = "fa-file";
                          }

                          let mb = doc.size > 1024 ? "MB" : "KB";
                          let sizeinMB = doc.size > 1024 ? Math.round(doc.size / 1024) : Math.round(doc.size);

                          return (
                            <Col lg={12} md={12} className="mb-3" key={index}>
                              <div className="new_doc_body">
                                <div className="w-100 d-flex justify-content-center resonsive_box">
                                  <div className="imgbox">
                                    <i className={`fa-solid fa-fw ${iconClass}`}></i>
                                  </div>
                                  <div className="infobox">
                                    <div className="info">
                                      <span>{doc.name}</span>
                                    </div>
                                    <div className="small_info">
                                      <div className="dot"></div>
                                      <div className="info_size">
                                        <span className="size">
                                          {sizeinMB}
                                          {mb}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="action_box">
                                  <Link
                                    className="sm_button"
                                    onClick={() => downloadFile(doc.id, doc.name, doc.type)}
                                  >
                                    <i className="fa-solid fa-download"></i>
                                  </Link>
                                  <Link
                                    className="sm_button"
                                    onClick={() => {
                                      setDocId(doc.id);
                                      setAddModalShow(true);
                                    }}
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </Link>
                                  <button
                                    className="sm_button"
                                    onClick={() => {
                                      setDocId(doc.id);
                                      setDeleteModalShow(true);
                                    }}
                                  >
                                    <i className="fa-solid fa-trash-can"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                    </Row>

                  </div>
                </TabPanel>
              </Tabs>
            </Col>
          </Row>
        </Container>

        <AddDocument
          show={addUploadModel}
          doc={getAllDoc}
          onHide={() => {
            getAllDoc();
            setUploadModel(false);
          }}
        />

        <DocEdit
          show={addModalShow}
          id={docId}
          doc={getAllDoc}
          onHide={() => {
            setAddModalShow(false);
          }}
        />

        <UserDocDelete
          show={deleteModalShow}
          id={docId}
          onHide={() => {
            setDeleteModalShow(false);
            setIsDoc(true);
          }}
        />
      </section>
    </>
  );
};

export default ChatBotSources;
